/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize useIndicatorParams View .
 */

// Dependencies
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useIndicatorParams = (indicatorId, paramId) => {
  const patientIndicators = useSelector((state) =>
    state.getIn(['AppState', 'patientIndicators'])
  );

  const [filteredParams, setfilteredParams] = useState([]);

  useEffect(() => {
    if (patientIndicators) {
      const indicators = patientIndicators.filter(
        (patientIndicator) => patientIndicator.indicador_id === indicatorId
      );
      const indicatorsParams = indicators.filter(
        (indicatorParam) => indicatorParam.parametro === paramId
      );
      setfilteredParams(indicatorsParams);
    }
  }, [patientIndicators]);

  return filteredParams;
};

export default useIndicatorParams;
